import {
  createCanvasCtx,
  getCanvasURL,
  initializeValues,
  writeToCanvas,
} from "./canvasHelper";

const createCanvas = async ({
  image,
  address,
  selectedPhotoPoint,
  featureType,
}) => {
  // Initialize data to be drawn over the photo.
  const { accountCode, coordinates, featureValue, structureName } =
    initializeValues({
      featureType: featureType,
      selectedPhotoPoint: selectedPhotoPoint,
    });

  // Create the canvas and context objects.
  let { canvas, ctx } = createCanvasCtx(image);

  // Write data over the canvas.
  writeToCanvas({
    accountCode: accountCode,
    address: address,
    canvas: canvas,
    coordinates: coordinates,
    ctx: ctx,
    featureValue: featureValue,
    structureName: structureName,
  });

  // Convert canvas to a URL and return it.
  const url = await getCanvasURL(canvas);
  return url;
};

export default createCanvas;
